const yRelation = [
  {
    source: 0.01,
    target: 9,
  },
  {
    source: 0.1,
    target: 33,
  },
  {
    source: 0.2,
    target: 45,
  },
  {
    source: 0.6,
    target: 56,
  },
  {
    source: 1,
    target: 63,
  },
  {
    source: 2.5,
    target: 76,
  },
  {
    source: Number.POSITIVE_INFINITY,
    target: 100,
  },
];

const xRelation = [
  {
    source: 0.1,
    target: 11,
  },
  {
    source: 0.5,
    target: 45,
  },
  {
    source: 1,
    target: 55,
  },
  {
    source: Number.POSITIVE_INFINITY,
    target: 100,
  },
];

export default {
  xRelation,
  yRelation,
};
